/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_Privacy_Consent_After_LinkInputs */

const en_cv_check_privacy_consent_after_link = /** @type {(inputs: Cv_Check_Privacy_Consent_After_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const de_cv_check_privacy_consent_after_link = /** @type {(inputs: Cv_Check_Privacy_Consent_After_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` habe ich gelesen.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Cv_Check_Privacy_Consent_After_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_privacy_consent_after_link = /** @type {((inputs?: Cv_Check_Privacy_Consent_After_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_Privacy_Consent_After_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_privacy_consent_after_link(inputs)
	return en_cv_check_privacy_consent_after_link(inputs)
});